import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { APIService } from "src/app/api/api.service";
import { NotifierService } from "src/app/_services/notifier.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-azure-wafr",
  templateUrl: "./azure-wafr.component.html",
  styleUrls: ["./wafr-shared.component.css", "./azure-wafr.component.css"],
})
export class AzureWafrComponent implements OnInit, OnDestroy {
  scanEnabled = false;
  userId = localStorage.getItem("selectedClientList");
  subscriptionId = localStorage.getItem("accountId") || "";
  urlPrefix = localStorage.getItem("role") == "Admin" ? "admin" : "client";

  loading = false;
  errorMessage: string = null;
  rows: any[] = [];
  lastRefreshedLabel = "-";
  currentMessage: any;
  destroyed = false;

  constructor(
    private apiService: APIService,
    private notifier: NotifierService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.subscriptionId = localStorage.getItem("accountId") || "";

    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let data: any = {};
      try {
        data = JSON.parse(msg);
      } catch (err) {
        return;
      }
      if (data?.value == null) {
        return;
      }
      if (data.key == "accountId") {
        this.subscriptionId = data.value;
        this.load();
      }
    });

    this.load();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    if (this.currentMessage) {
      this.currentMessage.unsubscribe();
    }
  }

  private formatDateTime(dateTime: string): string {
    if (!dateTime) {
      return "-";
    }
    const dt = new Date(dateTime);
    if (isNaN(dt.getTime())) {
      return dateTime;
    }
    return dt.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  private toScore(value: any): string {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    const score = Number(value);
    if (isNaN(score)) {
      return `${value}`;
    }
    return `${Math.round(score)}%`;
  }

  async load() {
    this.loading = true;
    this.errorMessage = null;
    this.rows = [];
    this.lastRefreshedLabel = "-";

    const headers: any = {
      Authorization: localStorage.getItem("t"),
    };

    const apiUrl =
      `${environment.apiURL}/${this.urlPrefix}/azure/wafr/api/v1/wafr/score` +
      `?user_id=${encodeURIComponent(this.userId)}` +
      `&subscription_id=${encodeURIComponent(this.subscriptionId)}`;

    try {
      const result: any = await this.apiService.getDataPromis(apiUrl, {}, headers);
      if (this.destroyed) {
        return;
      }

      if (result && result.subscription_id) {
        this.lastRefreshedLabel = this.formatDateTime(result.last_refreshed);
        this.rows = [
          {
            subscription_id: result.subscription_id,
            score: this.toScore(result.overall_percent),
          },
        ];
      } else {
        this.errorMessage =
          result?.error_message || result?.message || "Unable to load WAFR score.";
      }
    } catch (err: any) {
      this.errorMessage = err?.toString() || "Unable to load WAFR score.";
    } finally {
      this.loading = false;
    }
  }

  onScan() {
    if (!this.scanEnabled) {
      this.notifier.alert(
        "Info",
        "",
        "Scan is currently disabled for Azure Advisor.",
        "info",
        4000
      );
      return;
    }
  }

  openPillarScores(row: any) {
    if (!row?.subscription_id) {
      return;
    }
    this.router.navigate([
      "/dash/azure/wafr",
      row.subscription_id,
      "pillar-scores",
    ]);
  }
}
